import { Helmet } from "react-helmet";
import {
    Autocomplete,
    Box,
    Button,
    Container,
    Checkbox,
    Chip,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Divider,
    FormControl,
    Grid,
    InputLabel,
    Menu,
    MenuItem,
    Paper,
    Select,
    Tab,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tabs,
    TextField,
    Toolbar,
    Typography,
    Avatar,
    tableCellClasses,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { makeStyles, withStyles } from "@mui/styles";
import React, { useEffect } from "react";
import cssVariables from "../../theme/cssVariables";
import CloseIcon from "../../assets/images/plus-circle-fill.svg";
import linkedGoal from "../../assets/images/linkedGoal.svg";
import defaultProfile from "../../assets/images/defaultProfile.svg";
import arrowLinkedGoal from "../../assets/images/arrowLinkedGoal.svg";
import kpiArrow from "../../icons/kpiArrow.svg";
import * as Util from "../../services/global.service";
import evaluateService from "../../services/evaluate.service";
import { ReactComponent as MoreInfoIcon } from "../../assets/images/more-info.svg";
import { tabsClasses } from '@mui/material/Tabs';
import { ReactComponent as Nodata } from "../../assets/icons/nodata.svg";
const useStyles = makeStyles({
    boxLeft: {
        width: "25%",
        "padding-bottom": "25px",
    },
    boxRight: {
        width: "75%",
        "padding-bottom": "25px",
    },
    root: {
        'border-width': 0,
        'padding-left': 0,
        [`&.${tableCellClasses.body}`]: {
            'border-width': 0,
            'padding-left': 0,
        }
    },
    tab: {
        fontSize: "14px !important",
        fontWeight: "500 !important",
        '&.Mui-selected': {
            color: cssVariables.color.primary + " !important"
        },
        '&.MuiTab-root': {
            color: "#939393",
            "text-transform": "none"
        }
    },
    profileContainer: {
        width: 70,
        height: 70,
        borderRadius: "50%",
        marginTop: 3,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    fill: {
        '& > path': {
            fill: "#404349",
            width: "24px !important",
            height: "24px !important",
        },
        '& g > path': {
            fill: "#404349",
            width: "24px !important",
            height: "24px !important",
        },
    },
});

const MoreInfo = (props) => {
    const { name, proficiency, description, scale, open, close, data, formID } = props
    const classes = useStyles();
    const { t } = useTranslation()
    const [dataMain, setDataMain] = React.useState([]);
    const [valueTab, setValueTab] = React.useState("");
    const handleCloseDialog = () => {
        close(false);
    };
    useEffect(() => {
        if (formID !== null && formID !== undefined && formID !== "") {
            getDetailInfo()
        }
    }, [formID]);
    const getDetailInfo = () => {
        evaluateService.getDetailMoreInfo(formID).then(
            (rs) => {
                setDataMain(rs?.data)
                for (let index = 0; index <= rs?.data?.info.length - 1; index++) {
                    setValueTab(rs?.data?.info[0].category)
                }

            }).catch(() => {

            })
    }
    const handleChangeType = (_, val) => {
        setValueTab(val);
    };

    return (
        <Dialog onBackdropClick={() => {return false}} open={open} onClose={handleCloseDialog} aria-labelledby="form-dialog-title" fullWidth={true} maxWidth="md" PaperProps={{ sx: { padding: '30px 30px 15px',height: "85%" } }}>
            <DialogTitle id="form-add-dialog-title" fontSize={24} lineHeight="26.4px" fontWeight={600} sx={{ padding: "0 0 20px", color: "#404349", display: "flex" ,alignItems: "center" }}>
                <MoreInfoIcon className={classes.fill} /> 
                <Typography fontSize={24} lineHeight="26.4px" fontWeight={600} color="#404349" pl="10px">{Util.formatData(name, "More Info")}</Typography>
                <Box sx={{ position: "absolute", right: 0, margin: "30px 30px 0  0", top: 0 }}><img onClick={handleCloseDialog} className="clickable" src={CloseIcon} alt="browser" /></Box>
            </DialogTitle>
            <Divider />
            <DialogContent sx={{ padding: "0", "overflow-y": "unset" }}>
                {dataMain?.info !== undefined && dataMain?.info !== null && dataMain?.info.length > 0 ?
                    <>
                        <Grid item lg={11} md={11} sx={{ paddingTop: "20px", marginBottom: "18px", maxWidth: { xs: 900, sm: 900 } }}  >
                            <Tabs
                                value={valueTab}
                                indicatorColor="primary"
                                onChange={handleChangeType}
                                variant="scrollable"
                                scrollButtons
                                TabIndicatorProps={{
                                    style: {
                                        height: "8px",
                                        fontSize: "14px",
                                        lineHeight: "20.93px",
                                        textColor: "rgba(93, 161, 150, 1)"
                                    },
                                }}
                                sx={{
                                    [`& .${tabsClasses.scrollButtons}`]: {
                                        '&.Mui-disabled': { opacity: 0.3 },
                                    },
                                }}
                            >
                                {dataMain?.info.map((loRow) => (
                                    <Tab label={loRow?.category} value={loRow?.category} classes={{ root: classes.tab }} />
                                ))
                                }
                            </Tabs>
                        </Grid>
                        {valueTab !== "" ? dataMain?.info.map((loRow, index) => (
                            <Box pt="10px" sx={{ display: valueTab === loRow?.category ? 'block' : 'none' }}>
                                <TableContainer >
                                    <Table aria-label="simple table">
                                        <TableHead>
                                            <TableRow sx={{ borderBottom: "0.5px solid #E4E4E4", borderTop: "0.5px solid #E4E4E4", background: "#FAFAFA" }}>
                                                <TableCell sx={{ whiteSpace: "nowrap", width: "30%" }}><Typography variant="label" fontSize={14} fontWeight={500} lineHeight="20.93px" color="#A0A0A0">Type</Typography></TableCell>
                                                <TableCell sx={{ whiteSpace: "nowrap", width: "60%" }}><Typography variant="label" fontSize={14} fontWeight={500} lineHeight="20.93px" color="#A0A0A0">Result</Typography></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        {
                                            loRow?.informations !== undefined && loRow?.informations !== null && loRow?.informations.length > 0 ?
                                                loRow?.informations.map(item => (
                                                    <TableBody>
                                                        <TableRow sx={{ "vertical-align": "baseline" }}>
                                                            <TableCell component="th" scope="row" sx={{ paddingBottom: "10px" }}>
                                                                <Typography color="#404349" fontSize={16} lineHeight="23.92px">{item?.topic}</Typography>
                                                            </TableCell>
                                                            <TableCell component="th" scope="row" sx={{ paddingBottom: "10px" }}>
                                                                <Typography color="#404349" fontSize={16} lineHeight="23.92px" dangerouslySetInnerHTML={{ __html: item?.value }}></Typography>
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableBody>
                                                ))
                                                : null
                                        }
                                    </Table>
                                </TableContainer>
                            </Box>
                        ))
                            : null
                        }
                    </>
                    :
                    <Box sx={{ "padding-top": "50px", "text-align": "center", "padding-bottom": "500px" }}>
                        <Nodata />
                        <Typography color="#A0A0A0" fontWeight="500" fontSize={20} lineHeight="30px" >
                            {t('label.noData')}
                        </Typography>
                    </Box>
                }
            </DialogContent>
        </Dialog>
    );
};
export default MoreInfo;
